// Blocks checkout until the terms checkbox is ticked. The cart drawer is re-rendered on every
// cart change, so state lives in sessionStorage and all handlers are delegated from document.
(() => {
  if (window.termsCheckboxInit) return;
  window.termsCheckboxInit = true;

  const KEY = 'termsAccepted';
  const accepted = () => {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  const setAccepted = (value) => {
    try {
      sessionStorage.setItem(KEY, value ? '1' : '0');
    } catch (e) {}
  };

  const syncBoxes = () => {
    document.querySelectorAll('[data-terms-checkbox]').forEach((box) => {
      box.checked = accepted();
    });
    if (accepted()) {
      document.querySelectorAll('.terms-checkbox__error').forEach((el) => (el.hidden = true));
    }
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-terms-checkbox]')) return;
    setAccepted(event.target.checked);
    syncBoxes();
  });

  const block = (event) => {
    if (accepted()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelectorAll('.terms-checkbox__error').forEach((el) => (el.hidden = false));
    const box = document.querySelector('[data-terms-checkbox]');
    if (box) box.closest('.terms-checkbox').scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkouts/"]')) block(event);
    },
    true
  );
  document.addEventListener(
    'submit',
    (event) => {
      if (event.submitter && event.submitter.name === 'checkout') block(event);
    },
    true
  );

  // Re-apply state whenever the cart drawer re-renders.
  new MutationObserver(syncBoxes).observe(document.documentElement, { childList: true, subtree: true });
  syncBoxes();
})();
